import { Box } from '@mui/material';
import ProblemModal from '@acorn-portal/shared/src/components/modal/ProblemModal';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { useNavigate } from 'react-router';

interface IProps {
	children: React.ReactNode;
}

const MTAStartDateCheck = ({ children }: IProps) => {
	const MTA = useAppSelector((redux) => redux.midTermAdjustment);
	const navigate = useNavigate();
	return (
		<Box>
			{!MTA.invalidMtaStartDate ? children : null}
			<ProblemModal
				open={MTA.invalidMtaStartDate}
				title='Invalid Policy Date'
				description='Unable to make a change for the selected date. The date selected is either outside your policy term or you have a pending change on your policy. Please select a different date in order to proceed.'
				onClose={() => navigate(-1)}
				closeText='Go Back'
			/>
		</Box>
	);
};

export default MTAStartDateCheck;
